

// @ts-nocheck

/*

  The referral step's equivalent of ShareReviewOrderSelector — which share-channel buttons the
  respondent sees and in what order. Unlike review platforms there's nothing to configure per
  channel, so this is just toggle + drag. Persists [{methodCode}] (active ones, in display
  order) to the step's `shareMethods` field. A step saved before this field existed (undefined)
  loads as "all on" in the default order — the same fallback the survey app renders.

*/

import Vue from "vue";
import Draggable from "vuedraggable";
import InlineTooltipQuestion from "./InlineTooltipQuestion.vue";

//order here = the default display order for new/legacy steps
const ALL_METHODS = [
  {
    methodCode: "native",
    slug: "referralShareMore",
    fallback: "More ways to share",
    tip: "Opens the device's own share menu (Messages, Instagram, anything installed). Only appears on devices that support it — most phones do.",
    svg: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M18,16.1c-0.8,0-1.5,0.3-2,0.8l-7-4.1c0.1-0.2,0.1-0.5,0.1-0.8s0-0.6-0.1-0.8l7-4c0.5,0.5,1.2,0.8,2,0.8c1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.3,0,0.6,0.1,0.8l-7,4C7.5,9.3,6.8,9,6,9c-1.7,0-3,1.3-3,3s1.3,3,3,3c0.8,0,1.5-0.3,2-0.8l7.1,4.1C15,18.5,15,18.8,15,19c0,1.6,1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9S19.6,16.1,18,16.1z"/></svg>',
  },
  {
    methodCode: "sms",
    slug: "referralShareSMS",
    fallback: "Text a friend",
    tip: "Opens the device's text-message app with the link prefilled. Only appears on phones and tablets.",
    svg: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M20,2H4C2.9,2,2,2.9,2,4v18l4-4h14c1.1,0,2-0.9,2-2V4C22,2.9,21.1,2,20,2z M20,16H6l-2,2V4h16V16z"/></svg>',
  },
  {
    methodCode: "whatsapp",
    slug: "referralShareWhatsApp",
    fallback: "Share on WhatsApp",
    tip: false,
    svg: '<svg viewBox="0 0 112 112"><path fill="currentColor" d="M56.3,16c-22.1,0-40,17.9-40,40c0,7,1.9,13.9,5.4,19.9L16,96.9l21.7-5.7c5.8,3.2,12.3,4.8,18.6,4.8h0c22.1,0,40-17.9,40-40C96.3,33.9,78.4,16,56.3,16z M56.3,89.2L56.3,89.2c-5.9,0-11.7-1.6-16.8-4.6l-1.2-0.7l-12.4,3.2l3.3-12.1l-0.8-1.3c-3.3-5.2-5-11.2-5-17.4c0-18.3,14.9-33.2,33.3-33.2c8.9,0,17.2,3.5,23.5,9.8c6.3,6.3,9.7,14.6,9.7,23.5C89.6,74.3,74.7,89.2,56.3,89.2z M74.5,64.6c-1-0.5-5.9-2.9-6.8-3.2c-0.9-0.3-1.6-0.5-2.2,0.5c-0.7,1-2.5,3.2-3.1,3.9c-0.6,0.6-1.1,0.7-2.1,0.2c-1-0.5-4.2-1.6-8.1-5c-3-2.7-5-6-5.6-7c-0.6-1-0.1-1.5,0.4-2c0.5-0.5,1-1.1,1.5-1.7c0.5-0.6,0.7-1,1-1.7c0.3-0.7,0.2-1.3-0.1-1.8c-0.3-0.5-2.2-5.4-3.1-7.4c-0.8-1.9-1.6-1.7-2.2-1.7c-0.6,0-1.2,0-1.9,0c-0.6,0-1.7,0.2-2.6,1.2c-0.9,1-3.5,3.4-3.5,8.3c0,4.9,3.6,9.6,4.1,10.3c0.5,0.7,7.1,10.8,17.1,15.2c2.4,1,4.2,1.6,5.7,2.1c2.4,0.8,4.6,0.7,6.3,0.4c1.9-0.3,5.9-2.4,6.7-4.7c0.8-2.3,0.8-4.3,0.6-4.7C76.2,65.4,75.5,65.1,74.5,64.6z"/></svg>',
  },
  {
    methodCode: "facebook",
    slug: "shareOnFacebook",
    fallback: "Share on Facebook",
    tip: false,
    svg: '<svg viewBox="0 0 112.196 112.196"><path fill="currentColor" d="M73.2,20.4v15.8H63.8c-3.4,0-5.7,2.4-5.7,5.9v10.4h14.5l-1.9,15.4H58.1v39.9H42.1V67.9H28.5V52.5h13.6V40c0-13.5,8.3-19.6,20.4-19.6H73.2z"/></svg>',
  },
  {
    methodCode: "x",
    slug: "referralShareX",
    fallback: "Share on X",
    tip: false,
    svg: '<svg viewBox="0 0 112 112"><path fill="currentColor" d="M64.8,49.3L97.6,12h-7.8L61.3,44.4L38.6,12H12.4l34.4,48.9L12.4,100h7.8l30.1-34.2L74.3,100h26.2L64.8,49.3L64.8,49.3z M54.2,61.3l-3.5-4.9L23,18.2h12l22.4,31.4l3.5,4.9l29.1,40.8h-12L54.2,61.3L54.2,61.3z"/></svg>',
  },
  {
    methodCode: "email",
    slug: "referralShareEmail",
    fallback: "Email them",
    tip: "Lets the respondent send their friend an invite email straight from the survey.",
    svg: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M3,5h18c0.6,0,1,0.4,1,1v12c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1V6C2,5.4,2.4,5,3,5z M4,7.2V17h16V7.2l-8,5.6L4,7.2z M5.5,7L12,11.5L18.5,7H5.5z"/></svg>',
  },
  {
    methodCode: "copy",
    slug: "referralShareCopy",
    fallback: "Copy link",
    tip: false,
    svg: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M3.9,12c0-1.7,1.4-3.1,3.1-3.1h4V7H7c-2.8,0-5,2.2-5,5s2.2,5,5,5h4v-1.9H7C5.3,15.1,3.9,13.7,3.9,12z M8,13h8v-2H8V13z M17,7h-4v1.9h4c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1h-4V17h4c2.8,0,5-2.2,5-5S19.8,7,17,7z"/></svg>',
  },
];

export default Vue.extend({
  data() {
    return {
      methods: [],
    };
  },
  props: {
    fieldAddress: Array,
  },
  created(): void {
    this.refreshOptions();
  },
  methods: {
    buttonText(slug, fallback): string {
      //custom packs cloned before a key existed won't have it — fall back to English
      return this.$store.getters["dash/currentLanguagePack"][slug] || fallback;
    },
    refreshOptions(): void {
      const stored = this.field;
      const remaining = ALL_METHODS.map((m) => m.methodCode);
      const display = [];

      //steps saved before shareMethods existed (undefined) or with nothing on ([]) render
      //every channel in the survey app — mirror that here by starting all-on
      const legacyAllOn = !Array.isArray(stored) || stored.length === 0;

      if (!legacyAllOn) {
        stored.forEach((entry) => {
          const def = ALL_METHODS.find((m) => m.methodCode === entry.methodCode);
          if (!def || remaining.indexOf(entry.methodCode) === -1) return; //unknown or duplicate
          display.push({ ...def, text: this.buttonText(def.slug, def.fallback), active: true });
          remaining.splice(remaining.indexOf(entry.methodCode), 1);
        });
      }

      remaining.forEach((code) => {
        const def = ALL_METHODS.find((m) => m.methodCode === code);
        display.push({ ...def, text: this.buttonText(def.slug, def.fallback), active: legacyAllOn });
      });

      this.methods = display;
    },
  },
  watch: {
    oneOrMoreSelected(v) {
      this.$emit("handleErrors", {
        fieldAddress: this.fieldAddress,
        hasErrors: !v,
      });
    },
    methods: {
      handler(v): void {
        const toPush = [];
        v.forEach((mthd) => {
          if (mthd.active) toPush.push({ methodCode: mthd.methodCode });
        });
        this.field = toPush;
      },
      deep: true,
    },
  },
  computed: {
    oneOrMoreSelected(): boolean {
      for (const mthd of this.methods) {
        if (mthd.active) return true;
      }
      return false;
    },
    field: {
      get: function (): any[] | undefined {
        // @ts-ignore
        return this.$store.getters["survey/stepField"](this.fieldAddress);
      },
      set: function (v: any[]): void {
        // @ts-ignore
        this.$store.commit("survey/CHANGE_FIELD", {
          // @ts-ignore
          fieldAddress: this.fieldAddress,
          val: v,
        });
      },
    },
  },
  components: {
    Draggable,
    InlineTooltipQuestion,
  },
});
